var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"commonBtn",on:{"click":function($event){return _vm.openFullScreenWindow()}}},[_vm._v(" "+_vm._s(_vm.$store.state.appConfig.layout.type == "full" ? "Exit Full-Layout" : "Open Full-Layout")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }